<script setup lang="ts">
import { computed } from "vue";
import { padStart } from "es-toolkit/compat";

import TcIcon from "@/Components/Extend/TcIcon.vue";

export interface NumberFieldProps {
  modelValue?: number;
}

const props = withDefaults(defineProps<NumberFieldProps>(), { modelValue: 0 });

const emit = defineEmits<{
  (e: "update:modelValue", value: number): void;
  (e: "change", value: number): void;
}>();

const value = computed(() => padStart(props.modelValue.toString(), 2, "0"));

const handleChange = (value: number) => {
  emit("update:modelValue", value);
  emit("change", value);
};
</script>

<template>
  <div class="number_field">
    <TcIcon
      class="number_field__minus"
      name="Less"
      color="content-mid"
      size="sm"
      @click="() => handleChange(props.modelValue - 1)"
    />

    <span class="number_field__value">
      {{ value }}
    </span>

    <TcIcon
      class="number_field__plus"
      name="Plus"
      color="content-mid"
      size="sm"
      @click="() => handleChange(props.modelValue + 1)"
    />
  </div>
</template>

<style scoped lang="scss">
.number_field {
  @include colors.bg(semantic, "white");
  @include text.general(low, m);
  @include sp.padding(y, 2);
  @include sp.padding(y, 2);
  @include radius(m);
  @include border(1, solid);
  @include colors.border(content, low);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: $space-2;
  height: $size-input-height;

  &__minus,
  &__plus {
    cursor: pointer;
  }

  &__plus {
    @include sp.margin(r, 3);
  }

  &__minus {
    @include sp.margin(l, 3);
  }

  &__value {
    @include text.general(low, m);
    @include colors.color(content, high);

    min-width: $space-7;
    text-align: center;
  }
}
</style>
